<br>
<span id="dynamic-component">Dynamic Component {{ index }}</span>:
<button id="dynamic-click-button" (click)="onClick()">Click {{ index }}</button>
